// export const api_url = 'https://admin.gptlegal.pro/api/admin'
// export const api_url_login = 'https://admin.gptlegal.pro/api'
// export const api_url1 = 'https://admin.gptlegal.pro/api'

export const api_url = 'https://admin.bottax.tech/api/admin' // TEST
export const api_url_login = 'https://admin.bottax.tech/api'
export const api_url1 = 'https://admin.bottax.tech/api'